import { useDynamicTranslation } from '../../hooks';
export var SKILLS_STRING_SPLITTER = ', '; //@TODO consider "locale friendly" solution
export function useListOfSkills(skills) {
    if (skills === void 0) { skills = []; }
    var dt = useDynamicTranslation().dt;
    return skills
        .map(function (obj) {
        return dt(obj);
    })
        .join(SKILLS_STRING_SPLITTER);
}
